import Card from '../../componentsNew/Card';
import Typography from '../../componentsNew/Typography';
import { TabsAnaliseArtigo } from './components/TabsAnaliseArtigo';
import { TabsSeoArtigo } from './components/Sugestoes/Seo';
import { OptiTabs } from '@componentsNew/OptiTabs';

export function CardSugestoes() {
  const data = [
    {
      label: 'Palavras',
      value: 'palavras',
      content: <TabsAnaliseArtigo />,
    },
    {
      label: 'Link building',
      value: 'link-building',
      content: <TabsAnaliseArtigo />,
    },
    {
      label: 'SEO',
      value: 'seo',
      content: <TabsSeoArtigo />,
    },
  ];

  return (
    <>
      <Typography component="h4-semibold">Sugestões</Typography>

      <OptiTabs
        className="bg-[#f9fafb] border-[2px] border-solid border-[#eceef2] p-0"
        classNameBody="h-auto m-0 p-2 text-text-secundary"
        indicatorProps="bg-neutras-white border-[2px] border-solid border-[#D0D5DD] top-[-2px] left-[-2px] right-[-2px] shadow-none m-0"
        selecionado={'palavras'}
        data={data}
      />
    </>
  );
}
